/*global $, document, ZebraPin */


var LazyLoadBackground = function ($elems) {
    "use strict";

    var self = this;
    self.$elems     = $elems;
    self.paddingBG  = 1000; // how many pixels below view port does image load
    self.paddingIM  = 500;
    self.$window    = $(window);

    self.init = function () {

        /**
         * Process elements 1st time when page load
         */
        self.processElements($(this));

        /**
         * Process elements as page scrolls
         */
        window.addEventListener('scroll', _.throttle(self.processElements, 30));

        self.$window.on('resizeEnd', function () {
           self.processElements();
        });
    };

    /**
     * Process the list of elements and show background if needed
     */
    self.processElements = function () {
        self.$elems.each(function (i) {
            var $elem = $(this),
            yOff = 0;

            if (self.hasElementScrolledIntoView($elem)) {

                if ($elem.data('type') === 'background') {
                    self.loadBackground($elem);

                    if ($elem.hasClass('parallax')) {

                        yOff = ($elem.closest('.page').offset().top - self.$window.scrollTop() - 150) * 0.1 ;

                        $elem.css({
                            "transform" : "translate3d(0," + yOff + "px, 0)"
                        });
                    }

                } else {
                    self.loadImageSrc($elem);
                }

            }

        });
    };


    /**
     * Load a background image
     * @param $elem
     */
    self.loadBackground = function ($elem) {
        var background = self.getImageForElement($elem);
        $elem.css('background-image', "url("+ background +")");
    };

    /**
     * Load as an image src
     * @param $elem
     */
    self.loadImageSrc = function ($elem) {
        var image = self.getImageForElement($elem);
        $elem.attr('src', image);
    };

    /**
     * Get the image url for the viewport size
     * @param $section
     * @returns {string}
     */
    self.getImageForElement = function ($section) {
        var dataKey = "image-" + ResponsiveUtil.getSize();
        
        if ($section.hasClass('single-size-image')) {
            dataKey = "image-src";
        }
        return $section.data(dataKey);
    };

    /**
     * Determine if the element as scrolled into view
     * @param $elem
     * @param real
     * @returns {boolean}
     */
    self.hasElementScrolledIntoView = function ($elem, real)
    {
        var docViewTop = self.$window.scrollTop(),
            docViewBottom = docViewTop + self.$window.height(),
            elemTop = $elem.offset().top,
            padding = self.paddingIM;

        if (real === undefined) {
            real = false
        }

        if ($elem.data('type') === 'background') {
            padding = self.paddingBG;
        }
        return elemTop < docViewBottom + (real?0:padding);

    };

    if (self.$elems.length > 0) {
        self.init();
    }
};


var ContentSlideIn = function ($elems) {
    "use strict";
    var self = this;
    self.$elems = $elems;
    self.$timeLineCont = $("#timeline-container");


    self.init = function () {
        self.$elems.each(function () {
            var $trigger     = $(this),
                $content     = $trigger.prev('.slide-in'),
                $closer      = $content.siblings('.time-period-content-closer'),
                $body        = $('body'),
                $page        = $trigger.parents('.page'),
                $parallax    = $page.find('.parallax'),
                scrollToHash = "";

            $trigger.on('click', function (e) {
                e.preventDefault();
                self.loadShows($content);
                scrollToHash = UrlUtil.ParseHash($(this));
                ScrollUtil.ScrollTo($(scrollToHash), 200, 1);
                setTimeout(function () {
                    self.showContent($body, $page, $closer, $parallax);
                }, 300);
            });


            $page.find('.slide-in').on('click', function () {
               if ($page.hasClass('open')) {
                   self.closeContent($body, $page, $closer, $parallax);
               }
            });

            $page.find('.slide-in').find('.slide').on('click', function (e){
                e.stopPropagation();
            });

            $closer.on('click', function (e) {
                e.preventDefault();
                self.closeContent($body, $page, $closer, $parallax);
            });

            var scrollTest = function () {
                $content.find('.col').each(function () {
                    var $col = $(this);
                    if ($col.find('.content-wrap').length = 1 && $col.height() < $col.find('.content-wrap').height()) {
                        $col.parents('.row').addClass('scrollable');
                    }
                });
            };

            $(window).on('resizeEnd', function () {
                scrollTest();
            });

            scrollTest();


        });
    };

    self.loadShows = function ($content) {

        $content.find('.lazy-load-on-trigger').each(function () {
            var $img = $(this);
            $img.attr('src', $img.data("image-src"));
        });

        new SlideShow($content.find('.slideshow'));
        $content.find('.slideshow').addClass('initiated');

        new VideoShow($content.find('.videoshow'));
        $content.find('.videoshow').addClass('initiated');

    };



    self.showContent = function ($body, $period, $closer, $parallax) {
        $period.addClass('open');
        $body.addClass('no-scroll');
        self.$timeLineCont.removeClass('show');

        setTimeout(function () {
            $period.find('.slide-in').addClass('scroll-y');
        }, 1000);

        $closer.addClass('show');
        self.blurParallax($parallax);
    };

    self.closeContent = function ($body, $period, $closer, $parallax) {

        self.resetScroll($period);
        self.sharpenParallax($parallax);
        self.resetVideoShow($period);
        self.resetSlideShow($period);

        $period.removeClass('open');


        setTimeout(function () {
            $body.removeClass('no-scroll');
            $period.find('.scroll-y').removeClass('scroll-y');

        }, 500);

        $closer.removeClass('show');
        self.$timeLineCont.addClass('show');

    };

    self.resetSlideShow = function ($period) {
        $period.find('.images .lSPager li:first a').trigger('click');
    };

    self.resetVideoShow = function ($period) {
        $period.find('.video .video-player').attr('src', '');
        $period.find('.video .thumbnails .lslide:first a').data('autoplay', null);
        $period.find('.video .thumbnails .lslide:first a').trigger('click');

    };

    self.resetScroll = function ($period) {
        $period.find(".slide-in").scrollTop(0);
    };

    self.blurParallax = function ($parallax) {
        if (Modernizr.cssfilters) {
            $parallax.addClass('blur');
        } else {
            $parallax.addClass('darken');
        }

    };

    self.sharpenParallax = function ($parallax) {
        $parallax.removeClass('blur').removeClass('darken');
    };

    if (self.$elems.length > 0) {
        self.init();
    }
};

/**
 * Pin an element to the header of the page.
 * @param $elems
 * @constructor
 */
var PinIt = function ($elems) {
    "use strict";

    var self = this;
    self.$elems = $elems;
    self.$timeLineCont = $("#timeline-container");

    self.init = function () {

        self.getTopOffset = function ($elem, $header) {

            var topSpacing = $header.height();
            if (typeof $elem.data('pin-offset') !== 'undefined') {
                topSpacing = $elem.data('pin-offset');
            }

            return topSpacing;
        };


        self.$elems.each(function () {
            var $elem = $(this),
                $header = $("header"),
                offset = $header.height(),
                syncActive = "trigger-" + $elem.parents('.pin-container').prop('id'),
                syncActivePrev,
                options = {
                    topSpacing: self.getTopOffset($elem, $header),
                    zIndex: 99,
                    className: "pinned",
                    wrapperClassName: "pinned-wrapper"
                };

            $(window).on('resizeEnd', function () {
                options = {
                    topSpacing: self.getTopOffset($elem, $header),
                    zIndex: 99,
                    className: "pinned",
                    wrapperClassName: "pinned-wrapper"
                };
                $elem.sticky(options);
            });


            $elem.sticky(options);

            //What happens when a time period title "Sticks" a the top
            $elem.on('sticky-start', function () {

                $('.page.is-current').removeClass('is-current');
                $elem.closest('.page').addClass('is-current');

                $elem.addClass('pinned');

                //Set which sections should have the parallax animation happen
                self.updateParallaxibleSections($elem);

                //Save the last section that was pinned
                self.updatePinnedCookie($elem.parents('.pin-container').prop('id'));

                // Update any synced menus
                ScrollUtil.ActiveSync(".page-trigger", syncActive);

                // Scroll the time line to the required period point
                if ($elem.data('period-point')) {
                    self.syncTimeLine($("#period-point-" + $elem.data('period-point')));
                }

                $elem.removeClass('unPinned');

            });

            //What happens when a time period title "Un Sticks" from the top
            $elem.on('sticky-end', function () {
                var $currentPinned = $(".pinable.pinned:last"),
                    currentPinnedIndex = $currentPinned.index();

                syncActivePrev = "trigger-" + $(".pinable.pinned").eq(currentPinnedIndex - 2).parents('.pin-container').prop('id');

                //Set which sections should have the parallax animation happen
                self.updateParallaxibleSections($elem);

                //Save the last section that was pinned
                self.updatePinnedCookie($currentPinned.parents('.pin-container').prop('id'));

                // Scroll the time line to the required period point
                if ($currentPinned.data('period-point')) {
                    self.syncTimeLine($("#period-point-" +  (parseInt($currentPinned.data('period-point')) - 1)));
                }

                // Update any synced menus
                ScrollUtil.ActiveSync(".page-trigger", syncActivePrev);

                $elem.addClass('unPinned');
                $elem.removeClass('pinned');

                $('.page.is-current').removeClass('is-current');
                $elem.closest('.page').prev('.page').addClass('is-current');
            });

        });
    };

    self.updateParallaxibleSections = function ($elem) {
        var parallaxIds = [],
            sectionId = $elem.parents('section.page').index();

        parallaxIds.push(sectionId - 1);
        parallaxIds.push(sectionId);
        parallaxIds.push(sectionId + 1);

        $('.page').each(function(i) {
            if ($.inArray(i, parallaxIds) !== -1) {
                $(this).find('.parallaxible').addClass('parallax');
            } else {
                $(this).find('.parallaxible').removeClass('parallax');
            }
        });

        $('.pages').attr('data-parallaxible', parallaxIds.join('|'));
    };

    self.updatePinnedCookie = function (id) {
        if (typeof id !== 'undefined') {
            CookieUtil.Set('pinned', id);

        }
    };

    self.syncTimeLine = function ($elem) {
        TimelineUtil.ReCenterActive($elem);
    };


    if (self.$elems.length > 0) {
        self.init();
    }
};

/**
 * Implement scroll to hash on a collection of anchor tags.
 * The hash of the anchor href should point to the id of the element to scroll to.
 * The anchor can override the speed with the data-speed attribute.
 * @param $elems
 * @param speed
 * @constructor
 */
var ScrollToTrigger = function ($elems, speed) {
    "use strict";

    var self = this;
    self.$elems = $elems;
    self.speed = speed;

    self.init = function () {
        self.$elems.each(function () {
            var $elem = $(this),
                hash  = UrlUtil.ParseHash($elem),
                speed = (typeof $elem.data('speed') === 'undefined'?750:$elem.data('speed')),
                autoSpeed = $elem.data('auto-speed'),
                toIndex;

            if (hash === '#') {
                hash = $elem.data('target');
            } else {
                toIndex = $('section'+hash).index();
            }
            $elem.on('click', function (e) {
                e.preventDefault();
                if (autoSpeed !== false) {
                    var fromId          = $('.timeline-trigger.pinned:last').parent('section').prop('id'),
                        fromIndex       = $('section#' + fromId).index(),
                        distance        = Math.abs(fromIndex - toIndex),
                        normalizedSpeed = (150 * distance) + speed;
                } else {

                    normalizedSpeed = 750;
                }

                var target = $(hash).addClass('current-page');

                ScrollUtil.ScrollTo(target, normalizedSpeed);

                if ($elem.data('sync-group') && $elem.data('sync-active')) {
                    var syncActive = $elem.data('sync-active'),
                        syncGroup = $elem.data('sync-group');

                    ScrollUtil.ActiveSync(syncGroup, syncActive);
                }

                $(window).on('resizeEnd', function () {
                    ScrollUtil.ScrollTo(target, 500);
                });
            });

        });
    };

    if (self.$elems.length > 0) {
        self.init();
    }
};

/**
 * Pin to a section that has been saved on page load. IE: when switching languages, keep the last viewed section pinned
 * @constructor
 */
var PrePin = function () {
    "use strict";

    var self = this;

    self.init = function () {
        var $goToElem,
            pinnedId = CookieUtil.Get('pinned');

        if ($('body').hasClass('lang-source-param')) {
            $goToElem = $('#' + pinnedId);

            if ($goToElem.length === 1) {
                ScrollUtil.ScrollTo($goToElem, 1);
            }
        } else {
        }
    };

    self.init();
};

/**
 * Implement the timeline preview windows which pop-up on hover/click of a timeline period dot
 * @constructor
 */
var TimelinePreview = function () {
    "use strict";
    var self = this;

    self.$elem          = $('#timeline-preview');
    self.$timeContainer = $("#timeline-container");
    self.$timeline      = $("#timeline-scale");
    self.$triggers      = self.$timeline.find('.period-point');

    self.init = function () {
        self.$triggers.each(function () {
            var $trigger = $(this),
                $goToElem = $("#time-period-" + $(this).data('target'));
            $trigger.on('mouseover click', function (e) {
                e.preventDefault();

                $(".preview-open").not($trigger).removeClass('preview-open');

                if ($trigger.hasClass('preview-open')) {
                    if (e.type === 'click') {
                        ScrollUtil.ScrollTo($goToElem);
                        $trigger.removeClass('preview-open').addClass('active');
                    }

                } else {
                    $trigger.addClass('preview-open');

                    self.initPreviewFor($trigger);

                    setTimeout(function () {

                        self.showWindow();

                        self.positionWindow($trigger);

                    }, 0.3);
                }


            });

        });

        self.$timeContainer.on('mouseleave', function () {
            self.destructPreviewWindow();
        });
    };

    self.destructPreviewWindow = function () {
        if (self.$elem.is(":visible")) {
            setTimeout(function () {
                self.hideWindow();
                $('.preview-open').removeClass('preview-open');
            }, 300);
        }
    };


    self.initPreviewFor = function ($elem) {
        var prevImage = $elem.data('preview-image'),
            prevTitle = $elem.data('preview-title'),
            prevDate  = $elem.data('preview-date');
        
        self.$elem.find('.preview-image img').attr('src', prevImage);
        self.$elem.find('.preview-title').html(prevTitle);
        self.$elem.find('.preview-date').html(prevDate);
    };

    self.showWindow = function () {
        self.$elem.addClass('show');
    };

    self.hideWindow = function () {
        self.$elem.removeClass('show').css({"left" : -200});

    };

    self.positionWindow = function ($elem) {
        var timeCenter = $elem.width() / 2,
            timeLeft   = $elem.position().left,
            prevWidth  = self.$elem.width();


        self.$elem.css({
            left: $elem.data('left-percent') + "%"
        });
    };

    self.init();
};

/**
 * Handle any svg to png switching. We are going to assume
 * that you're browser handles SVG, but if not we add the no-svg class or render a png instead.
 * @constructor
 */
var SvgHandler = function () {
    "use strict";

    var self = this;

    self.init = function () {
        if (!Modernizr.svgasimg) {
            self.switchToPngAsBackground();
            self.switchToPngAsImageSrc();
        }
    };

    self.switchToPngAsBackground = function () {
        $(".svg-background").addClass('no-svg');
    };

    self.switchToPngAsImageSrc = function () {

        $(".svg-image").each(function () {
            var $img = $(this);

            $img.attr('src', $img.attr('src').replace('.svg', '.png'));
        });
    };

    self.init();
};

/**
 * Enable the drop down menu on the menu icon trigger
 * Close the menu on window resize.
 * @param $trigger
 * @param $menu
 * @constructor
 */
var DropMenu = function ($trigger, $menu) {
    "use strict";

    var self = this;
    self.$trigger = $trigger;
    self.$menu = $menu;

    self.init = function () {

        self.$trigger.on('click', function (e) {
            e.preventDefault();

            if ($menu.hasClass('closed')) {
                self.$menu.removeClass('closed');
            } else {
                self.$menu.addClass('closed');
            }

        });

        $(window).on('resizeEnd', function () {
            if (!self.$menu.hasClass('closed')) {
                self.$menu.addClass('closed');
            }
        });

        self.$menu.find('a.scroll-trigger').each(function () {
           var $item = $(this);

            $item.on('click', function () {
                self.$menu.addClass('closed');
            })
        });
    };

    self.init();
};

/**
 * Implement the dragging/scrolling timeline
 * @param $elem
 * @constructor
 */
var TimelineScrolling = function ($elem) {
    "use strict";
    var self = this;
    self.$elem = $elem;
    self.$cont = $elem.find('.drag-container');
    self.$drag = $elem.find('.draggable');
    self.timeLineOptions = {
        axis: 'x',
        containment: self.$cont
    };

    self.init = function () {

        $(window).on('resizeEnd', function () {
            self.resizeContent();
        });

        self.resizeContent();
    };

    /**
     * redefine the timeline draggable area and initialize the dragging
     */
    self.resizeContent = function () {

        if (self.$elem.width() < self.$drag.width()){

            var width =  (self.$elem.width() + 2 * (self.$drag.width() - self.$elem.width())) + 100 + 'px',
                left = (-1 * (self.$drag.width() - self.$elem.width())) - 50 + 'px';

            self.$cont.css({
                'width' : width,
                'left' : left
            });

            self.$drag.draggabilly(self.timeLineOptions);
        }
    };

    if (self.$elem.length > 0) {
        self.init();
    }
};

/**
 * Trigger hide, show the time line from the bottom.
 * @constructor
 */
var TimelineShowHide = function () {

    "use strict";
    var self = this;
    self.$timeLine = $("#timeline-container");
    self.$show     = $(".timeline-show:first");
    self.$hide     = $(".timeline-hide:first");

    self.init = function () {

        $(window).on('scroll', function () {

            if (ScrollUtil.HasScrolledIntoView(self.$show)) {
                self.$timeLine.addClass('show');
            } else {
                self.$timeLine.removeClass('show');
            }

            if (ScrollUtil.HasScrolledIntoView(self.$hide)) {
                self.$timeLine.removeClass('show');
            }

        });

    };

    self.init();
};

/**
 * Hover icon image src switching.
 * all icons with class icon-hover must have two versions of image one with _nml  for normal image and one with _hov for hover image.
 * @param $elems
 * @constructor
 */
var HoverIcon = function ($elems) {
    "use strict";
    var self = this;
    self.$elems = $elems;

    self.init = function () {
        self.$elems.each(function () {
            var $elem = $(this);
            $elem.on('mouseenter', function () {
                $elem.attr('src', $elem.attr('src').replace('_nml', '_hov'));
            });

            $elem.on('mouseleave', function () {
                $elem.attr('src', $elem.attr('src').replace('_hov', '_nml'));
            });
        });

    };

    if (self.$elems.length > 0) {
        self.init();
    }
};


/**
 * Position the timeline scale initially so that the first date is to the left of the viewport
 * @constructor
 */
var TimelineInitPosition = function ($elem) {
    "use strict";
    var self = this;
    self.$elem = $elem;


    self.init = function () {
        var $timelineScale = self.$elem.find("#timeline-scale"),
            $dragContainer = self.$elem.find('.drag-container');

        $timelineScale.css({
            "left" : $dragContainer.width() - $timelineScale.width() - 32 + "px"
        });
    };

    if (self.$elem.length > 0) {
        self.init();
    }
};

/**
 * Slide show player for still images
 * @param $elems
 * @constructor
 */
var SlideShow = function ($elems) {
    "use strict";
    var self = this;
    self.$slideshows = $elems;
    self.padding = 500;
    self.$window = $(window);
    self.options = {
        gallery:true,
        item: 1,
        loop: false,
        slideMargin: 0,
        thumbItem: 9
    };

    self.init = function () {
        self.$slideshows.each(function () {
            var $slideshow = $(this);

            if ($slideshow.data('init') !== true) {
                $slideshow.attr('data-init', 'true');
                $slideshow.lightSlider(self.options);
                $slideshow.addClass('initiated');
            }
        });

    };

    if (self.$slideshows.length > 0) {
        self.init();
    }
};

/**
 * Video show player for YouTube videos
 * @param $elems
 * @constructor
 */
var VideoShow = function ($elems) {
    "use strict";

    var self = this;
    self.$videoShows = $elems;
    self.padding = 500;
    self.$window = $(window);
    self.options = {
        loop: false,
        pager: false,
        vThumbWidth:100
    };

    self.init = function () {
        self.$videoShows.each(function () {
            var $videoShow = $(this),
                $scene = $videoShow.find('.video-container');

            self.$window.on('resizeEnd', function () {
               self.resizePlayer($scene);
            });

            if ($videoShow.data('init') !== true) {
                $videoShow.attr('data-init', 'true');
                $videoShow.find('.thumbnails').lightSlider(self.options);
                $videoShow.addClass('initiated');
                $videoShow.find('.thumbnails .thumbnail').each(function () {
                    self.initThumbnail($(this), $scene);
                });
                self.reset($videoShow.find('.thumbnails'));
            }
          //  $videoShow.find('.thumbnails').lightSlider(self.options);

        });
    };

    self.initThumbnail = function ($thumb, $scene) {
        $thumb.on('click', function (e) {
            e.preventDefault();

            var videoId = $thumb.data('video'),
                $videoPlayer = $scene.find('.video-player'),
                playerUrlBase = $videoPlayer.data('base-url'),
                autoplay = "",
                fullscreen = "&fs=0";


            if (playerUrlBase !== undefined) {
                if ($thumb.data('autoplay')) {
                    autoplay = "&autoplay=1";
                } else {
                    //reset autoplay
                    $thumb.data('autoplay', true);
                }

                $videoPlayer.attr('src', playerUrlBase + videoId + '?' + fullscreen + '&hl=' + $('html').attr('lang') + autoplay);
                self.resizePlayer($scene);
            }

        });
    };

    self.resizePlayer = function ($scene) {
        var $videoPlayer = $scene.find('.video-player'),
            $slide = $scene.parents('.videoshow'),
            $thumbs = $scene.siblings('.lSSlideOuter');

        $videoPlayer.attr('width', $scene.width());
        $videoPlayer.attr('height', $slide.height() - $thumbs.height() - 20);

    };

    self.reset = function ($videoShow) {
        setTimeout(function () {
            $videoShow.find('.thumbnail:first').data('autoplay', false).trigger('click');
        }, 300);

    };

    if (self.$videoShows.length > 0) {
        self.init();
    }
};


var ContactForm = function ($elems) {
    "use strict";
    var self = this;
    self.$elems = $elems.find('form');
    self.$loader = $elems.find('.loading');
    self.$success = $elems.find('.success-msg');


    self.init = function () {
        self.$elems.each(function (){
           var $form = $(this);

           $form.on('submit', function (e) {
              e.preventDefault();
                self.$loader.removeClass('hidden');
              $.ajax({
                url: $form.attr('action'),
                  method: $form.attr('method'),
                  data:$form.serialize()
              })
              .done(function () {
                self.$success.removeClass('hidden');
                $form.trigger('reset');
              })
              .always(function () {
                  self.$loader.addClass('hidden');
              })
              ;
           });
        });

    };


    if ($elems.length > 0){
        self.init();
    }
};

var SlidePaginators = function ($elems) {

    var self = this;
    self.$elems = $elems;

    self.init = function () {
        //Add scroll event to each slide in container, when scrolling stops detect based on slide position and slide height which slide is active in the window
        self.$elems.siblings('.slide-in').scroll(function() {
            var $scrollElem = $(this);
            clearTimeout($.data(this, 'scrollTimer'));
            $.data(this, 'scrollTimer', setTimeout(function() {

                var found = false,
                    currentIdx = -1;

                $scrollElem.find('.slide').each(function (i){
                    var $slide = $(this);
                    if (!found && Math.abs($slide.position().top) < $slide.height()) {
                        found = true;
                        currentIdx = i;
                    }
                });
                $scrollElem.siblings('.slide-paginator').find('.pager.active').removeClass('active');
                $scrollElem.siblings('.slide-paginator').find('.pager').eq(currentIdx).addClass('active');
            }, 250));
        });

        self.$elems.each(function () {
            var $pagerGroup = $(this);
            $pagerGroup.find('.pager').each(function (idx) {
                var $pager = $(this);
                $pager.on("click", function (e) {
                    e.preventDefault();
                    $pager.siblings('.active').removeClass('active');
                    $pager.addClass('active');
                    var $slideIn = $pager.parents('.content').find(".slide-in.scroll-y"),
                        targetHeight = parseInt($pager.parents('.content').find('.slide:first').outerHeight() + 40) * idx,
                        incHeight = $slideIn.scrollTop(),
                        timer = setInterval(function () {
                            if (incHeight < targetHeight) {
                                incHeight += 10;
                                if (incHeight > targetHeight) {
                                    timer = clearInterval(timer);
                                }
                            } else {
                                incHeight -= 10;
                                if (incHeight < targetHeight) {
                                    timer = clearInterval(timer);
                                }
                            }

                            $slideIn.scrollTop(incHeight);
                        }, 10);

                });
            });

        });

        $()
    };



    if ($elems.length > 0) {
      self.init();
    }
};

var SocialDropMenu = function ($menu, $header) {

    var self = this;
    self.$menu = $menu;
    self.$header = $header;

    self.init = function () {
        self.$header.on('mouseleave', function () {
            if (!self.$menu.hasClass('closed')) {
                self.$menu.addClass('closed');
            }
        });
    };


    if ($menu.length === 1 && $header.length === 1) {
        self.init();
    }
};

var PeriodPointTouchEvents = function ($points) {

    var self = this;
    self.$elems = $points;
    self.init = function () {
        self.$elems.each(function () {
            var $elem = $(this);

            $elem.on('touchstart', function () {
               $elem.trigger('mouseover');
            });

            $elem.on('touchend', function () {
                $elem.trigger('mouseout');
                $elem.trigger('click');
            })
        });
    };

    if ($points.length > 0 && Is.iOS()) {
        self.init();
    }
};

var WindowResizeEndReset = function ($pages) {

    var self = this;
    self.$window = $(window);
    self.$body = $('body');
    self.$pages = $pages;

    self.init = function () {
        self.$window.on('resizeEnd', function () {
            var newWidth = self.$window.width();
            if (typeof self.$body.data('width') === undefined) {
                self.$body.data('width', newWidth);
            }

            if (self.$body.data('width') !== newWidth) {
                ScrollUtil.ScrollTo(self.$pages.filter('.is-current'), 500);
            }
            self.$body.data('width', newWidth);

        });

    };

    if ($pages.length > 0) {
        self.init();
    }
};

$(document).on('ready', function () {
    "use strict";

    CustomEvent.createAll();


    var $timelineContainer    = $('#timeline-container');

    new LazyLoadBackground($('.lazy-load-background'));
    new SvgHandler();
    new ContentSlideIn($('.time-period-content-trigger'));
    new PrePin();
    new PinIt($('.pinable'));
    new ScrollToTrigger($('.scroll-trigger'), 1000);
    new TimelineScrolling($timelineContainer);
    new TimelinePreview();
    new TimelineShowHide();
    new TimelineInitPosition($timelineContainer);
    new DropMenu($('.menu-handle'), $('.drop-menu'));
    new DropMenu($('.social-menu-handle'), $('.social-drop-menu'));
    new HoverIcon($('.icon-hover'));
    new ContactForm($('.contact-form'));
    new SlidePaginators($(".slide-paginator"));
    new SocialDropMenu($(".social-drop-menu"), $('header'));
    new PeriodPointTouchEvents($(".period-point"));
    new WindowResizeEndReset($(".page"));



    if (Is.Safari()) {
        $('html').addClass('is-safari');
    }

    if (Is.iOS()) {
        $('html').addClass('is-ios');
    }
});
